<template>
  <el-dialog
    title="登录"
    :visible.sync="dialogVisible"
    width="30%"
   >
   <Layout>
      <el-form
      :model="form"
      :rules="rules"
      ref="form">
      <el-form-item prop="companyName">
        <el-input
          v-model="form.companyName"
          @keyup.enter.native="primaryBtnClick"
          @input="clearPhoneCode"
          prefix-icon="el-icon-office-building"
          placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item prop="userName">
        <el-input
          v-model="form.userName"
          @keyup.enter.native="primaryBtnClick"
          @input="clearPhoneCode"
          prefix-icon="el-icon-user"
          placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          @keyup.enter.native="primaryBtnClick"
          @input="clearPhoneCode"
          show-password
          prefix-icon="el-icon-lock"
          placeholder="请输入密码"></el-input>
      </el-form-item>
      <template v-if="needValiCodePic">
        <el-form-item prop="validationCode">
          <div class="valicode-row">
            <el-input
              v-model="form.validationCode"
              @keyup.enter.native="primaryBtnClick"
              class="valicode-input"
              placeholder="验证码" />
            <div class="valicode-pic">
              <img :src="byteImg" />
            </div>
            <div class="valicode-btn">
              看不清楚?<el-button @click="getValiCodePic" class="link" type="link">换一张</el-button>
            </div>
          </div>
        </el-form-item>
      </template>
      <template v-if="needPhoneVerifyCode">
        <div v-if="!!phoneCodeMsg" class="phoneCodeMsg">{{phoneCodeMsg}}</div>
        <el-form-item>
          <div class="valicode-row">
            <el-input
              v-model="phoneVerifyCode"
              style="width: 240px"
              @keyup.enter.native="primaryBtnClick"
              class="valicode-input"
              placeholder="验证码" />
            <el-button
              style="width: 88px; height: 40px;"
              @click="getPhoneVerifyCode" :disabled="!!getPhoneVerifyCodeTimmer">
              {{ getPhoneVerifyCodeBtnText }}
            </el-button>
          </div>
        </el-form-item>
        <div v-if="!!phoneVerifyCodePhoneNum" class="phoneCodeTip">
          验证码已发送至{{ phoneVerifyCodePhoneNum }}
        </div>
        <div v-if="phoneVerifyCodeError" class="phoneCodeTipError">
          验证码错误，请重新输入
        </div>
      </template>
      <el-form-item
        class="mt-40">
        <PrimaryBtn
          :disabled="primaryBtnDisabled"
          @click="primaryBtnClick">
          {{isLoging ? '登录中' : '立即登录'}}
        </PrimaryBtn>
      </el-form-item>
    </el-form>
    <div class="footer">
      没有账号？<el-button class="link" type="link" @click="handleRegister">免费注册</el-button>
    </div>
   </Layout>
</el-dialog>
</template>

<script>
import Layout from './components/LoginLayout.vue'
import PrimaryBtn from './components/LoginPrimaryBtn'
import {loginServer, getValiCodePicSrc, loadUserInfo, phoneCodeGet } from './servers.js'
import { switchIdentity } from '@/pages/login/servers'

export default {
  components: {
    PrimaryBtn,
    Layout
  },
  data() {
    return {
      dialogVisible: false,
      validationCode: '',
      phoneVerifyCode: '',
      form: {
        companyName: '',
        password: '',
        userName: ''
      },
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入登录密码', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入登录账户', trigger: 'blur'}
        ],
        validationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      needValiCodePic: false,
      byteImg: '',
      isLoging: false,
      grayList: [],
      needPhoneVerifyCode: false,
      getPhoneVerifyCodeTimmer: null,
      getPhoneVerifyCodeCD: 60,
      phoneVerifyCodePhoneNum: '',
      phoneCodeMsg: '',
      phoneVerifyCodeError: false,
      pageId: 'shop',
      productId: ''
    }
  },
  watch: {
    needValiCodePic(val) {
      if (val) {
        this.$set(this.form, 'validationCode', '')
        this.getValiCodePic()
      } else {
        this.$delete(this.form, 'validationCode')
      }
    }
  },
  computed: {
    primaryBtnDisabled() {
      return this.isLoging
    },
    getPhoneVerifyCodeBtnText() {
      if (!this.getPhoneVerifyCodeTimmer) {
        return '获取验证码'
      }
      return `(${this.getPhoneVerifyCodeCD < 10 ? '0' : ''}${this.getPhoneVerifyCodeCD})s`
    }
  },
  methods: {
    method_open(pageId, productId) {
      this.dialogVisible = true;
      this.pageId = pageId;
      this.productId = productId || ''
    },
    method_close() {
      this.dialogVisible = false;
    },
    handleRegister() {
      this.$emit('registe')
    },
    async primaryBtnClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async login() {
      try {
        let data = {
          ...this.form,
          password: this.$utils.login.encodePwd(this.form.password)
        }
        if (this.needPhoneVerifyCode) {
          data.phoneVerifyCode = this.phoneVerifyCode
        }
        this.isLoging = true

        const res = await loginServer(data)
        
        if (typeof res === 'string') {
          !(/\/verify.html/.test(res) || /\/mobile.html/.test(res)) && this.$message.error(res)
          this.isLoging = false
          return;
        } else if (res._code === -1) {
          this.$message.error(res.msg)
          if (!this.needValiCodePic) {
            this.needValiCodePic = true
          } else {
            this.getValiCodePic()
          }
          this.isLoging = false
          return;
        } else if ([-2, -3].includes(res._code)) {
          this.isLoging = false;
          this.loginVerifyFlow(res);
          return;
        } else if (!res){
          this.isLoging = false
          return;
        }
        await this.loadUserInfo2Jump();
        this.isLoging = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoging = false
      }
    },
    // 切换身份
    async switchIdentity(loginIdentity) {
      const success = await switchIdentity(loginIdentity);
      const success2 = await loadUserInfo()
      return success && success2;
    },
    async loadUserInfo2Jump() {
      const success = await loadUserInfo()
      const supplierId = this.$route.query.supplierId
      let bindRelationUrl = '';
      if(this.pageId == 'shop'){
        bindRelationUrl = `/distributor/supplier/info?supplierId=${supplierId}`
      } else {
        bindRelationUrl = `/distributor/supplier/productDetail/${this.productId}?supplierId=${supplierId}`
      }
      if (success) {
        const { loginIdentity, companyId } = this.$store.getters.userInfo
        let isSelf = companyId === Number(supplierId);
        switch (Number(loginIdentity)) {
          case 0:
          this.$router.push({name: 'l_choose'});
          break;
          case 1:
            if(isSelf) {
              // 自己登录且为供销商，直接跳往/supplier/commodity/myShop
              bindRelationUrl = '/supplier/commodity/myShop'
            } else {
              // 不是自己登录又是供销商身份需要切换为分销商身份进行跳转
              await this.switchIdentity(2)  
            }
          bindRelationUrl ? this.$router.push(bindRelationUrl) :
          this.$router.push("/");
          break;
          case 2:
            if (isSelf) {
              // 自己登录且为分销商，切换完身份跳往/supplier/commodity/myShop
              await this.switchIdentity(1)
              bindRelationUrl = '/supplier/commodity/myShop'
            }
          bindRelationUrl ? this.$router.push(bindRelationUrl) :
          this.$router.push("/");
          break;
          default: this.$message.warning(`未知身份-${loginIdentity}`);
        }
        this.needValiCodePic = false;
      } else {
        this.$message.error('获取用户信息失败')
      }
    },
    async getValiCodePic() {
      try {
        const src = await getValiCodePicSrc()
        if (!src) return ;
        this.byteImg = src
      } catch (error) {
        console.log(error)
      }
    },
    // 登录接口返回状态为login_verify_random需要填写手机验证码
   loginVerifyFlow({companyId, accountId, msg, _code}) {
      this.phoneVerifyCodeParams = {companyId, accountId}
      this.phoneVerifyCodePhoneNum = '';
      this.phoneVerifyCodeError = false;
      this.needPhoneVerifyCode = true;
      if (_code === -3) {
        this.phoneVerifyCodeError = true;
        this.phoneVerifyCodePhoneNum = '';
      } else {
        this.phoneVerifyCode = '';
        this.phoneVerifyCodeError = false;
        this.phoneCodeMsg = msg || '请输入验证码'
      }
    },
    async getPhoneVerifyCode() {
      this.setupPhoneVerifyCodeCD();
      let res = await phoneCodeGet(this.phoneVerifyCodeParams);
      if (!res) {
        this.phoneVerifyCodePhoneNum = ''
      } else {
        this.phoneVerifyCodePhoneNum = res
        this.phoneVerifyCodeError = false
      }
    },
    setupPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer = setInterval(() => {
        if (this.getPhoneVerifyCodeCD < 1) {
          this.clearPhoneVerifyCodeCD()
        } else {
          this.getPhoneVerifyCodeCD -= 1
        }
      }, 1000);
    },
    clearPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer && clearInterval(this.getPhoneVerifyCodeTimmer)
      this.getPhoneVerifyCodeTimmer = null;
      this.$nextTick(() => {
        this.getPhoneVerifyCodeCD = 60
      })
    },
    clearPhoneCode() {
      this.clearPhoneVerifyCodeCD()
      this.needPhoneVerifyCode = false;
    }
  },
  created() {
    const {companyName, userName, password} = this.$route.params
    const _form = {
      companyName: companyName || '',
      userName: userName || '',
      password: password || '',
    }
    this.form = _form
    this.$store.dispatch('clearShops');
  },
  beforeDestroy() {
    this.clearPhoneVerifyCodeCD()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
  background-color: #396CF3;
}
.mt-40 {
  margin-top: 40px;
}
.footer {
  text-align: center;
  color: #9c9c9c;
  font-size: 13px;
  margin-bottom: 40px;

  .link {
    padding: 0;
    color: #396CF3;
  }
}
.phoneCodeMsg {
  padding: 10px 0;
  color: red;
  border-top: 1px solid #ccc;
}
.valicode-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  .link {
    padding: 0;
    color: #396CF3;
  }

  .valicode-input {
    width: 110px;
    margin-right: 8px;
  }
  .valicode-pic {
    margin-right: 8px;
    width: 121px;
    height: 40px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .valicode-msg-input {
    width: 239px;
    margin-right: 10px;
  }
  .valicode-msg-btn {
    padding: 0 18px;
    height: 40px;
    border-radius: 4px;
  }
}
.phoneCodeTip {
  color: #4b8b38;
}
.phoneCodeTipError {
  color: red;
}
</style>